import { Inbox } from 'lucide-react';
import { Button } from '@/components/Button';

/**
 * v0.5⑧ 経営会議PDCA 専用の空状態コンポーネント (設計 §7-0(b))。
 *
 * ⚠️ 既存 `components/EmptyState.tsx` を使わない理由: そのアクションボタンが
 * `border-brand-red text-brand-red` かつ `px-3 py-1` (約26px) で `checkTapTargetSize` (44px) に
 * 落ちる (3巡目 design-expert M-A)。呼び出しが66画面あり本機能のスコープを大きく超えるため、
 * `EmptyState` 自体の是正は別増分とし (`docs/OPEN_ITEMS.md`)、本機能はこの専用コンポーネントを使う。
 */
export type BoardEmptyStateProps = {
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
};

export function BoardEmptyState({ title, description, action }: BoardEmptyStateProps) {
  return (
    <div className="py-10 text-center flex flex-col items-center gap-2">
      <Inbox size={32} className="text-text-sub" aria-hidden />
      <div className="text-sm text-text-body">{title}</div>
      {description && <div className="text-xs text-text-sub">{description}</div>}
      {action && (
        <Button variant="secondary" size="sm" className="mt-2" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
}
